





















import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import DocumentHandlerApi from "../services/DocumentHandlerApi";
import { t } from "@/plugins/i18n";

interface Data {
  loading: boolean;
}

interface Methods {
  createDocument(): void;
  openDocument(data: any): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    ApiSearchPage,
  },
  props: {
    urlFilterTable: { type: String },
    urlFilterId: { type: Number },
    browserTitle: { type: String },
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    createDocument() {
      this.$router.push(`/documents/create`);
    },

    async openDocument(item) {
      const ret = DocumentHandlerApi.generateDocumentDownLoadLink(item.id);
      window.open(ret);
      console.log(ret);
    },
  },

  computed: {
    apiSearchUrl() {
      if (this.$props.urlFilterId && this.$props.urlFilterTable) {
        return `documents/apisearch/${this.$props.urlFilterTable}/${this.$props.urlFilterId}`;
      }
      return "documents/apisearch";
    },

    createButtonText() {
      return t("Document_UjDokumentumFeltoltese");
    },

    columns: (): ApiSearchColumn[] => [
      {
        field: "id",
        title: t("Iktatoszam"),
        // filterable: false,
      },
      {
        field: "typeName",
        title: t("Document_FajlTipusa"),
      },
      {
        field: "created",
        title: t("LetrehozasDatuma"),
        type: ColumnType.Date,
      },
      {
        field: "createdBy",
        title: t("Letrehozo"),
      },
      {
        field: "fileName",
        title: t("FajlNeve"),
      },
      {
        field: "fileExtension",
        title: t("Document_FajlKiterjesztese"),
      },
      {
        field: "description",
        title: t("Megjegyzes"),
      },
      {
        field: "version",
        title: t("Document_Verzio"),
      },
      { cell: "commandTemplate", filterable: false },
    ],
  },
});
